export const escapeForbiddenSymbolsInQuery = (query: string): string =>
  query ? `${query.replace(/[\\"*?]/g, '\\$&')}` : '';
